import { useState } from "react";

/**
 * Custom hook to manage the resume upload flow state and handlers.
 *
 * @param {Function} onUploadSuccess - Callback to execute after successful upload
 * @returns {Object} State and handlers for resume upload flow
 */
export const useResumeUploadFlow = ({ onUploadSuccess }) => {
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [isUploadWidgetOpen, setIsUploadWidgetOpen] = useState(false);
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);

  /**
   * Initiates the upload flow by closing the preview modal and opening
   * either the warning modal (if resume exists) or upload widget directly.
   *
   * @param {boolean} hasExistingResume - True if user already has a resume
   */
  const handleInitiateUpload = (hasExistingResume) => {
    setIsPreviewModalOpen(false);

    if (hasExistingResume) {
      setIsWarningModalOpen(true);
    } else {
      setIsUploadWidgetOpen(true);
    }
  };

  const handleUploadComplete = async (resumeStorageLocation) => {
    await onUploadSuccess(resumeStorageLocation);
    setIsPreviewModalOpen(true);
  };

  const handleClosePreview = () => {
    setIsPreviewModalOpen(false);
    setIsWarningModalOpen(false);
    setIsUploadWidgetOpen(false);
  };

  const handleCloseWarning = () => {
    setIsWarningModalOpen(false);
  };

  const handleOpenWarningWidget = () => {
    setIsWarningModalOpen(false);
    setIsUploadWidgetOpen(true);
  };

  const handleCloseUploadWidget = () => {
    setIsUploadWidgetOpen(false);
    setIsWarningModalOpen(false);
  };

  return {
    isPreviewModalOpen,
    isUploadWidgetOpen,
    isWarningModalOpen,

    setIsPreviewModalOpen,
    setIsUploadWidgetOpen,
    setIsWarningModalOpen,

    handleInitiateUpload,
    handleUploadComplete,
    handleClosePreview,
    handleCloseWarning,
    handleOpenWarningWidget,
    handleCloseUploadWidget,
  };
};
